import ACTUALIZAR_AUDITORIA_INFORME_OBSERVACION_SOLO_ESTATUS from '@/graphql/mutations/administracion/auditorias/observaciones/actualizarAuditoriaInformeObservacionSoloEstatus.gql';
import AUDITORIA_INFORME_OBSERVACIONES from '@/graphql/querys/administracion/auditorias/auditoriaInformeObservaciones.gql';
import AUDITORIA_INFORME_RESPUESTAS from '@/graphql/querys/administracion/auditorias/auditoriaInformeRespuestas.gql';

export default {
  apollo: {
    auditoriaInformeRespuestas: {
      query: AUDITORIA_INFORME_RESPUESTAS,
      variables() {
        return {
          idInforme: this.$route.params.idInforme,
        };
      },
    },
    auditoriaInformeObservaciones: {
      query: AUDITORIA_INFORME_OBSERVACIONES,
      variables() {
        return {
          idInforme: this.$route.params.idInforme,
        };
      },
    },
  },
  computed: {
    getAuditoriaInformeRespuestas() {
      if (!this.auditoriaInformeRespuestas) return [];
      return this.auditoriaInformeRespuestas;
    },
  },
  methods: {
    actualizarEstatusObservacion(observaciones, estatusDescripcion) {
      observaciones.forEach(
        async (observacion) => {
          const { idInforme } = this.$route.params;
          const id = observacion.idObservacion;
          const estatus = estatusDescripcion;

          await this.$apollo.mutate({
            mutation: ACTUALIZAR_AUDITORIA_INFORME_OBSERVACION_SOLO_ESTATUS,
            variables: {
              id,
              observacion: {
                estatus,
              },
            },
            update: (store, { data: { actualizarAuditoriaInformeObservacionSoloEstatus } }) => {
              const query = {
                query: AUDITORIA_INFORME_OBSERVACIONES,
                variables: { idInforme },
              };
              const { auditoriaInformeObservaciones } = store.readQuery(query);
              const auditoriaInformeObservacionesCopia = auditoriaInformeObservaciones.slice();
              const index = auditoriaInformeObservacionesCopia
                .findIndex((o) => o.id === actualizarAuditoriaInformeObservacionSoloEstatus.id);
              if (index !== -1) {
                auditoriaInformeObservacionesCopia
                  .splice(index, 1, actualizarAuditoriaInformeObservacionSoloEstatus);
              }
              store.writeQuery({
                ...query,
                data: {
                  auditoriaInformeObservaciones: auditoriaInformeObservacionesCopia,
                },
              });
            },
          }).then(() => {
            this.mixMensajeSuccess();
          }).catch((err) => {
            this.mixMensajeError(err);
          });
        },
      );
    },

    getEvaluarRespuestas() {
      const respuestas = this.getAuditoriaInformeRespuestas;
      if (!respuestas) return [];
      const respuestasDetalles = respuestas.map(({ detalles }) => detalles.map((d) => ({
        idRespuesta: d.idAuditoriaInformeRespuesta,
        idDetalle: d.id,
        idDesglose: d.idAuditoriaInformeObservacionDetalle,
        esRespuestaParcial: d.esRespuestaParcial,
      }))).flat(2);
      const observacionesDesgloses = this.getObservacionesDesgloses(respuestasDetalles);
      return observacionesDesgloses;
    },
    getObservacionesDesgloses(respuestasDetalles) {
      const observacionesDesgloses = this.informe.observaciones
        .map((observacion) => ({
          idObservacion: observacion.id,
          numero: observacion.numero,
          estatus: observacion.estatus,
          detalles: observacion.detalles.map((detalle) => ({
            idObservacion: detalle.idAuditoriaObservacion,
            idDesglose: detalle.id,
            enRespuestasDetallesCompletas: respuestasDetalles
              .map((respuestasDetalle) => {
                if (respuestasDetalle.idDesglose === detalle.id
                  && respuestasDetalle.esRespuestaParcial === false) {
                  return true;
                }
                return false;
              }).find((respuesta) => respuesta === true) || false,
            enRespuestasDetalles: respuestasDetalles
              .map((respuestasDetalle) => {
                if (respuestasDetalle.idDesglose === detalle.id) {
                  return true;
                }
                return false;
              }).find((respuesta) => respuesta === true) || false,
          })),
        }))
        .filter((o) => o.detalles.length > 0)
        .map((o) => ({
          idObservacion: o.idObservacion,
          numero: o.numero,
          estatus: o.estatus,
          enviadasCompletas: !o.detalles.some((d) => d.enRespuestasDetallesCompletas === false),
          enviadasParciales: o.detalles.some((d) => d.enRespuestasDetalles === true),
          enviadas: o.detalles.filter((d) => d.enRespuestasDetalles === true),
          noEnviadas: o.detalles.filter((d) => d.enRespuestasDetalles === false),
        }));
      return observacionesDesgloses;
    },

  },
};
